import { render, staticRenderFns } from "./company-form.vue?vue&type=template&id=453fc429&"
import script from "./company-form.vue?vue&type=script&lang=js&"
export * from "./company-form.vue?vue&type=script&lang=js&"
import style0 from "./company-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports